import * as React from 'react';
import {Skeleton, Stack, Box} from '@mui/material';
import { useColorMode } from "../ColorModeContext";



export default function SkeletonGallery() {
  const {colorMode} = useColorMode();

  return (
  
    <Box sx={{ display:'flex', flexDirection:"row", p:'10px 0px 0px 0px', height:"202px"}}>
    
        <Box sx={{w:'100%', flex:'.8', }}>
        <Skeleton variant='rounded' width={"100%"} height={'100%'} sx={{ p:'3px', bgcolor: colorMode ? 'grey.900' : 'grey.200' }} />
        </Box>
        <Box display={'flex'} flexDirection={'column'} sx={{flex:'.2'}} >
        <Skeleton variant="rounded" width={"100%"} height={'50%'} sx={{flexDirection:1, ml:'10px', mb:'10px', bgcolor: colorMode ? 'grey.900' : 'grey.200'}} animation={false} />
        <Skeleton variant="rounded" width={"100%"} height={'50%'} sx={{flexDirection:1, ml:`10px`, bgcolor: colorMode ? 'grey.900' : 'grey.200'}} animation={false}/>
        </Box>
   
    </Box>
    
  );
}